<template>
    <div>
        <div id="console" style="white-space:pre;">-{{ mtest }}-</div>
        <div id="presentationArea">
            <CanvasPresentation v-for="canvasPresentation in canvasPresentations" :canvasPages="canvasPresentation.canvasPages" :data-presentationId="canvasPresentation.id" :key="canvasPresentation.id" :page="currentPage" :id="canvasPresentation.id" v-show="canvasPresentation.id === currentPresentation"></CanvasPresentation>
            <!--            <CanvasPage v-for="canvasPage in CanvasPages" :key="canvasPage.id" :canvas="canvasPage.canvas" :id="canvasPage.id" :page="canvasPage.page"></CanvasPage>-->
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import * as pdfjsLib from 'pdfjs-dist/webpack';
    import uniqueId from 'lodash.uniqueid';
    import CanvasPresentation from './CanvasPresentation.vue';

    export default {
        name: 'Receiver',
        components: {
            CanvasPresentation,
        },
        data: function () {
            return {
                mtest: "",
                connectionIdx: 0,
                messageMode: 'command',
                receiving: {},
                connection: undefined,
                //                pages: Number,
                //                page: Number,
                //                CanvasPages: [],
                currentPresentation: '',
                currentPage: 1,
                canvasPresentations: [],
                loadState: { value: 0, nextPage: undefined, nextPresentation: undefined },
            };
        },
        props: {
            type: String,
            target: String
        },
        created: function () {
            if (navigator.presentation.receiver) {
                this.mtest = "I am a receiver!";
                navigator.presentation.receiver.connectionList.then(list => {
                    this.mtest += "\nAnd I have Connections!";
                    list.connections.map(connection => this.addConnection(connection));
                    list.addEventListener('connectionavailable', function (event) { this.addConnection(event.connection); });
                });
            }
        },
        mounted: function () {
            document.defaultView.addEventListener('resize', this.rescale);
        },
        methods: {
            sendState: function () {
                this.connection.send(JSON.stringify({
                    command: 'state',
                    state: 'ready',
                    message: 'ready',
                    mode: this.messageMode,
                }));
                this.mtest += "SendState";
            },
            parseCommand: function (message) {
                console.log(JSON.stringify(message));
                switch (message.command) {
                    case 'ping':
                        this.sendState();
                        this.mtest += '\nPing';
                        break;
                    case 'loadFile':
                        this.messageMode = 'data';
                        this.receiving.dataType = message.type;
                        this.receiving.id = message.id;
                        this.sendState();
                        break;
                    case 'setPresentationAndPage':
                        if (this.loadState.value) {
                            this.loadState.nextPresentation = message.presentation;
                            this.loadState.nextPage = message.page;
                        } else {
                            this.currentPresentation = message.presentation;
                            this.currentPage = message.page;
                        }
                        //                        this.setPage();
                        break;
                    case 'setPage':
                        if (this.loadState.value) {
                            this.loadState.nextPage = message.page;
                        } else {
                            this.currentPage = message.page;
                        }
                        //                        this.setPage();
                        break;
                    default:
                        this.connection.send(JSON.stringify({
                            command: 'error',
                            message: 'unknown command',
                            error: undefined,
                        }));
                        this.mtest += "\nError"
                }
            },
            messageReceived: function (event) {
                if (this.messageMode === 'command') {
                    this.parseCommand(JSON.parse(event.data));
                } else if (this.messageMode === 'data') {
                    this.loadFile(this.receiving.dataType, event.data, this.receiving.id);
                    this.messageMode = 'command';
                    this.dataType = '';
                    this.sendState();
                }
                this.mtest += '> Message Received';
                console.log('> Message Received');
            },
            addConnection: function (connection) {
                this.mtest += "\nAdding Connection..."
                connection.connectionId = this.connectionIdx++;
                this.mtest += "\n" + JSON.stringify(connection);
                connection.addEventListener('message', this.messageReceived);
                this.connection = connection;
                this.sendState();
            },
            loadFile: function (type, file, id) {
                switch (type.toLowerCase()) {
                    case 'application/pdf':
                        console.log("File: " + typeof file);
                        var typedArray = new Uint8Array(file);
                        console.log("typedArray: " + typeof typedArray);
                        this.loadState.value++;
                        var loadingTask = pdfjsLib.getDocument(typedArray);
                        loadingTask.promise.then(function (pdf) {
                            var canvasPresentation = {
                                id: id,
                                type: type,
                                canvasPages: [],
                                page: 1,
                            };
                            Vue.set(this.canvasPresentations, this.canvasPresentations.length, canvasPresentation);
                            //                            self.canvasPresentations[id] = canvasPresentation;
                            this.currentPresentation = id;
                            this.currentPage = 1;
                            if (--this.loadState.value <= 0) {
                                if (this.loadState.nextPresentation) {
                                    this.currentPresentation = this.loadState.nextPresentation;
                                }
                                if (this.loadState.nextPage) {
                                    this.currentPage = this.loadState.nextPage;
                                }
                                this.loadState.value = 0;
                                this.loadState.nextPresentation = undefined;
                                this.loadState.nextPage = undefined;
                            }

                            //                            self.pages = pdf.numPages;
                            for (var pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                                var canvas = document.createElement("canvas");
                                canvas.classList.add("pdfPage");
                                canvas.classList.add("page-" + pageNum);
                                canvas.classList.add("page-last-" + (pdf.numPages - pageNum + 1));
                                if (pageNum == 1) {
                                    canvas.classList.add("page-first");
                                }
                                if (pageNum == pdf.numPages) {
                                    canvas.classList.add("page-last");
                                }
                                //                                canvas.setAttribute(self.$options._scopeId, "");
                                canvasPresentation.canvasPages.push({ id: uniqueId('CanvasPage-'), page: pageNum, canvas: canvas });
                                //                                self.$el.querySelector("#presentationArea").append(canvas);
                                this.renderPdfPage(pdf, pageNum, canvas);
                            }
                            this.page = 1;
                            //                            self.setPage();
                        }.bind(this));
                        break;
                    default:
                }
            },
            renderPdfPage: function (pdf, pageNum, canvas) {
                //var self = this;
                pdf.getPage(pageNum).then(function (page) {
                    var context = canvas.getContext("2d");
                    context.fillStyle = "#000000";
                    context.fillRect(0, 0, canvas.width, canvas.height);
                    var viewport = page.getViewport({ scale: 1.0 });
                    var presentationHeight = window.innerHeight;
                    var presentationWidth = window.innerWidth;
                    this.mtest += '\n\nPage ' + pageNum + '\n------';
                    var dpr = window.devicePixelRatio;
                    //dpr = 1;
                    this.mtest += '\nPresentationscreen Dimensions: ' + presentationWidth + ' x ' + presentationHeight + ' @ ' + dpr;
                    var xScale = presentationWidth / viewport.width;
                    var yScale = presentationHeight / viewport.height;
                    var scale = Math.min(xScale, yScale) * dpr;
                    this.mtest += '\nScale: ' + scale + ' (' + xScale + ' x ' + yScale + ')';
                    canvas.width = Math.round(viewport.width * scale);
                    canvas.height = Math.round(viewport.height * scale);
                    this.mtest += '\nCanvas Dimensions: ' + canvas.width + ' x ' + canvas.height + ' @ ' + Math.floor((presentationWidth - viewport.width * scale) / 2) + ' x ' + Math.floor((presentationHeight - viewport.height * scale) / 2);
                    canvas.style.left = Math.max((presentationWidth - viewport.width * scale / dpr) / 2, 0) + 'px';
                    canvas.style.top = Math.max((presentationHeight - viewport.height * scale / dpr) / 2, 0) + 'px';
                    viewport = page.getViewport({ scale: scale });
                    var renderContext = {
                        canvasContext: context,
                        viewport: viewport,
                    };
                    page.render(renderContext).promise.then(function () {
                        //self.setPage();
                    });
                }.bind(this));
            },
            setPage: function () {
                if (this.page === undefined) {
                    return;
                }
                if (this.page < 1) {
                    this.page = 1;
                }
                if (this.page > this.pages) {
                    this.page = this.pages;
                }
                var current = this.$el.querySelector("#presentationArea .pdfPage.currentPage");
                while (current) {
                    current.classList.remove("currentPage");
                    current = this.$el.querySelector("#presentationArea .pdfPage.currentPage");
                }
                current = this.$el.querySelector("#presentationArea .pdfPage.page-" + this.page);
                if (current) {
                    current.classList.add("currentPage");
                    var rect = current.getBoundingClientRect();
                    current.style.left = Math.round((window.innerWidth - rect.width) / 2) + 'px';
                    current.style.top = Math.round((window.innerHeight - rect.height) / 2) + 'px';
                }
            },
            rescale: function () {
                var parent = this.$el.querySelector('#presentationArea');
                parent.querySelectorAll('canvas').forEach(function (canvas) {
                    var containerHeight = parent.getBoundingClientRect().height - getComputedStyle(parent).getPropertyValue('border-top-width').match(/\d+/)[0] - getComputedStyle(parent).getPropertyValue('border-bottom-width').match(/\d+/)[0];
                    var containerWidth = parent.getBoundingClientRect().width - getComputedStyle(parent).getPropertyValue('border-left-width').match(/\d+/)[0] - getComputedStyle(parent).getPropertyValue('border-right-width').match(/\d+/)[0];
                    var heightRatio = canvas.height / containerHeight;
                    var widthRatio = canvas.width / containerWidth;
                    var ratio;
                    if (heightRatio > widthRatio) {
                        ratio = heightRatio;
                    } else {
                        ratio = widthRatio;
                    }
                    var displayWidth = canvas.width / ratio;
                    var displayHeight = canvas.height / ratio;
                    canvas.style.left = Math.max((containerWidth - displayWidth) / 2, 0) + 'px';
                    canvas.style.top = Math.max((containerHeight - displayHeight) / 2, 0) + 'px';
                    if (heightRatio > widthRatio) {
                        canvas.style.minHeight = '100%';
                        canvas.style.minWidth = '0';
                    } else {
                        canvas.style.minWidth = '100%';
                        canvas.style.minHeight = '0';
                    }
                }, this);
            },
        }
    }
</script>
<style scoped>
    #presentationArea {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: #000000;
    }

    #console {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        background-color: #00000099;
        color: white;
    }
</style>
<!--<style>
    .pdfPage {
        max-height: 100vh;
        max-width: 100vw;
        position: absolute;
        visibility: hidden;
    }
    .pdfPage.currentPage {
        z-index: 10;
        visibility: visible;
    }
</style>-->
